import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { useUpdateProfile } from '_api/useProfile';
import { smallestMargin } from '_utils/sizes';
import { useThemeContext } from '_utils/themeContext';
import { showToast } from '_utils/toast';
import { HeimeText, Icon, Modal, Toggle } from 'Components';
import TouchableHeime from 'Components/TouchableHeime';

const NotificationsModal = ({ parkingNotificationEnabled }: { parkingNotificationEnabled: boolean }) => {
    const { t } = useTranslation();
    const { theme } = useThemeContext();
    const [visible, setVisible] = useState(false);
    const [modalParkingNotificationEnabled, setModalParkingNotificationEnabled] = useState(parkingNotificationEnabled);
    const { mutate: updateProfile, isPending: isUpdating } = useUpdateProfile();

    const handleBellPress = () => {
        setVisible(true);
    };

    const handleDismiss = () => {
        setVisible(false);
    };

    const handleSave = () => {
        updateProfile(
            {
                parking_sharing_availability_creator_notification: modalParkingNotificationEnabled,
            },
            {
                onSuccess: () => {
                    setVisible(false);
                },
                onError: () => {
                    showToast({
                        header: t('sharingNew:saveError'),
                        text: '',
                        type: 'error',
                    });
                },
            },
        );
    };

    return (
        <>
            <TouchableHeime
                style={{
                    marginTop: 'auto',
                    width: 40,
                    height: 40,
                    borderRadius: 20,
                    backgroundColor: parkingNotificationEnabled ? theme.lightGreen : theme.mediumBackground,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                accessibilityLabel={
                    parkingNotificationEnabled
                        ? t('bookingSharing:parking_notifications_enabled')
                        : t('bookingSharing:parking_notifications_disabled')
                }
                onPress={handleBellPress}
            >
                <Icon
                    name={parkingNotificationEnabled ? 'bell' : 'bellSlashed'}
                    color={parkingNotificationEnabled ? 'main' : 'darkGray'}
                />
            </TouchableHeime>
            {visible ? (
                <Modal
                    header={t('bookingSharing:notifications_title')}
                    onDismiss={handleDismiss}
                    content={
                        <View style={{ gap: smallestMargin }}>
                            <HeimeText variant="subtitle">{t('bookingSharing:notifications_description')}</HeimeText>
                            <Toggle
                                label={t('bookingSharing:parking_title')}
                                value={modalParkingNotificationEnabled}
                                onChange={(value) => {
                                    setModalParkingNotificationEnabled(value);
                                }}
                            />
                        </View>
                    }
                    buttons={[
                        {
                            text: t('global:confirm'),
                            isLoading: isUpdating,
                            onPress: handleSave,
                        },
                    ]}
                />
            ) : null}
        </>
    );
};

export default NotificationsModal;
